@if (showBanner) {
  <div class="cookie-banner">
    <div class="cookie-consent-banner">
      <p class="inter">Мы ценим вашу конфиденциальность. Пользуясь нашим сайтом, вы соглашаетесь с тем, что мы
        используем
        <a style="text-decoration: underline; color: unset;" href="https://onf.ru/cookies">cookies.</a></p>
      <button (click)="acceptCookies()"><img src="/assets/images/login/close.svg" alt=""></button>
    </div>
  </div>
}
